import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';
import 'firebase/remote-config';
import * as geofirestore from 'geofirestore';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.MEASUREMENT_ID,
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const firebaseAuth = firebase.auth;
export const firestore = firebase.firestore();
export const firebaseStorage = firebase.storage();
export const database = firebase.database();
export const GeoFirestore = geofirestore.initializeApp(firestore);
export const remoteConfig = firebase.remoteConfig();

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const appleProvider = new firebase.auth.OAuthProvider('apple.com').addScope('email');
